var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupbuy-wrapper"},[_c('GroupBuy',{attrs:{"platform":"web","dataSource":_vm.dataSource}}),_vm._v(" "),(_vm.qrcodeUrl)?_c('div',{staticClass:"qrcode-wrapper"},[_c('img',{staticClass:"qrcode",attrs:{"src":_vm.qrcodeUrl}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("微信扫码去分享")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }